import React, { createContext, useContext, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { landingTour } from '../components/tours/landing';
import { designTour } from '../components/tours/design';
import { galleryTour } from '../components/tours/gallery';
import { productsTour } from '../components/tours/products';
import { mockupsTour } from '../components/tours/mockups';
import { configureMockupTour } from '../components/tours/configureMockup';

const TOUR_STEPS = {
  landing: landingTour,
  design: designTour,
  gallery: galleryTour,
  products: productsTour,
  mockups: mockupsTour,
  configureMockup: configureMockupTour,
};

const TOUR_PATHS = {
  landing: '/',
  design: '/design',
  gallery: '/gallery',
  products: '/products',
  mockups: '/mockups',
  configureMockup: '/products', // User picks product first; configure has no generic entry
};

const TourContext = createContext(null);

export function TourProvider({ children }) {
  const navigate = useNavigate();
  const [run, setRun] = useState(false);
  const [steps, setSteps] = useState([]);

  const startTour = useCallback((tourName) => {
    const path = TOUR_PATHS[tourName];
    const tourSteps = TOUR_STEPS[tourName];
    if (!tourSteps || tourSteps.length === 0) return;
    if (path) navigate(path);
    setSteps(tourSteps);
    setTimeout(() => setRun(true), path ? 600 : 100);
  }, [navigate]);

  const stopTour = useCallback(() => {
    setRun(false);
  }, []);

  return (
    <TourContext.Provider value={{ run, setRun, steps, setSteps, startTour, stopTour }}>
      {children}
    </TourContext.Provider>
  );
}

export function useTour() {
  const ctx = useContext(TourContext);
  if (!ctx) throw new Error('useTour must be used within TourProvider');
  return ctx;
}
